/* IconLink - utility classes */
export const iconLinkClassName = '[&_a]:flex [&_a]:items-center [&_a]:text-black [&_a]:no-underline [&_a:hover]:text-[#668272] [&_a_.link-text]:inline-block [&_a_.icon]:inline-block [&_a_.icon]:w-[13px] [&_a_.icon]:mr-[5px] [&_a_.icon>svg]:inline-block';
